import { Component, Input, OnInit } from '@angular/core';
import { DropdownWithRulesInput } from '../../../../shared/models/lead/dropdownWithRules.input';
import { GetOriginsInput } from '../../../../shared/models/lead/getOrigins.input';
import { LeadService } from '../../../../shared/services/lead/lead.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-origin-selection-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class OriginSelectionDropdownComponent extends DropdownBaseComponent implements OnInit {

  @Input() loadOnInit = true;
  itemsLoaded = false;
  @Input() channel: string;

  constructor(
    private readonly dropdownService: DropDownService,
    private readonly leadService: LeadService,
    protected readonly translatorService: TranslatorService,
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);

    if (this.loadOnInit) {
      this.getOrigins();
    }
  }

  getOrigins(): void {

    this.leadService.getOrigins$(new GetOriginsInput(''), new DropdownWithRulesInput(this.channel, this.dropdownWithRules)
    ).subscribe(response => {
      this.itemsData = response.origins;
    });
  }
}
